import React, { useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import cx from "classnames";
import { Switch, Route, Redirect, Router, useHistory  } from "react-router-dom";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AdminNavbar from "beaktShared/components/Navbars/AdminNavbar.js";
import Footer from "beaktShared/components/Footer/Footer.js";
import Sidebar from "beaktShared/components/Sidebar/Sidebar.js";
import routes_before from "beaktMatriz/routesmatriz";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import { getTokenCookie } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { Chat } from "beaktShared/constants/Chat";
import AvisoInauguracao from "beaktMatriz/views/Avisos/AvisoInauguracao.js";
import { getAvisosPendentes, confirmarAviso, AVISOS_INAUGURACAO_ALTERADOS } from "beaktMatriz/views/Avisos/AvisoInauguracaoService.js";

var ps;

const useStyles = makeStyles(styles);

export default function Admin(props) {
   const history = useHistory();
   const { t } = useTranslation();
   
   const [session, setSession] = useState(getSessionCookie());
   const [routes, setroutes] = React.useState([]);
 
   useEffect(() => {
    Chat();
    getRoutesApi();
    validateToken("");
    getBoletinsOcorrenciaPendentes();
    getAvisosInauguracaoPendentes();
   },[]);

   // Recarrega o banner quando alguma tela altera a data de inauguração (sem precisar de CTRL+F5)
   useEffect(() => {
    window.addEventListener(AVISOS_INAUGURACAO_ALTERADOS, getAvisosInauguracaoPendentes);
    return () => window.removeEventListener(AVISOS_INAUGURACAO_ALTERADOS, getAvisosInauguracaoPendentes);
   });

   useEffect(() => {
    setInterval(()=> {    
      var token = getTokenCookie();
      if (token === null) {
        props.history.push("/auth/login");
        return false;
      }
    }, 3000);

    validateToken(history.location.pathname);
   },[history.location.pathname]);

  const validateToken = (activeRoute) => {    
    if (session != null && session.tipoPerfil != 0 && session.tipoPerfil != 4)
    {
      props.history.push("/auth/login");
      return false;      
    }
      
    var token = getTokenCookie();

    if (session === null || token === null) {
      props.history.push("/auth/login");
      return false;      
    }
    
    if (token.expired){
      props.history.push("/auth/login");  
      return false;      
    }
                     
    if (activeRoute != "" && 
        activeRoute != "/adminmatriz/home" && 
        activeRoute != "/adminmatriz/accessdenied")
    {
      activeRoute = verifyPathFather(activeRoute);
      let activeRouteNormalizada = activeRoute.toLowerCase().replace("/adminmatriz/", "");
      
      if (session.tipoPerfil != 0) {
        let endPoint = "usuarios/checkpermission/" + session.estabelecimentoId + "/" + session.id + "/" + activeRouteNormalizada;
        UseGetApiSimple(endPoint).then(result => {
          if (result.data != true)
            props.history.push("/adminmatriz/accessdenied"); 
            return false;           
        })        
      }
    }
  };

  const verifyPathFather = (activeRoute) =>{

    activeRoute = activeRoute.replace("/adminmatriz/", "").toUpperCase();
        
    let pathfiltered = routes_before.filter((prop) => {
      return ((prop.collapse == null && ("/"+activeRoute) === prop.path.toUpperCase())
      || (prop.collapse == true && prop.views.filter((f) => f.path.toUpperCase() == ("/"+activeRoute)).length > 0)
      )
    });
    
    if(pathfiltered[0])
    {       
       if (pathfiltered[0].collapse){
          pathfiltered = pathfiltered[0].views.filter((f) => f.path.toUpperCase() == ("/"+activeRoute));
          if (pathfiltered[0].hasOwnProperty('pathFather'))
            activeRoute = pathfiltered[0].pathFather.replace("/","");            
       }
       else if(pathfiltered[0].hasOwnProperty('pathFather'))
          activeRoute = pathfiltered[0].pathFather.replace("/","");
    }   
    
    return activeRoute;
  };

  const getRoutesApi = () =>
  {
    if (session.tipoPerfil == 0)
      setroutes(routes_before);
    else{
      UseGetApiSimple("usuarios/getpermissoes/" + session.estabelecimentoId + "/" + session.id, "").then(result => {      
        updateRoutes(routes_before, result.data);
      });    
    }    
  };
  
  const updateRoutes = (listroutes, permissions) => {            
    let listfiltered = listroutes.filter((prop) => {
      return ((prop.collapse == null && permissions.filter((p) => ("/"+p.path) === prop.path).length > 0)
              || (prop.collapse == true && permissions.filter((p) => prop.views.filter((f) => f.path == ("/"+p.path)).length > 0).length > 0)
              || (prop.pathFather)
              || (prop.path === "/accessdenied")
              || (prop.path === "/home")
            )
    });
    setroutes(listfiltered);
  };

  const [boletinsOcorrencia, setboletinsOcorrencia] = React.useState([]);
  const getBoletinsOcorrenciaPendentes = () => {
    UseGetApiSimple("boletimocorrencia/alert/" + session.franquiaId).then(result => {
      if (result.status === 200){
        setboletinsOcorrencia(result.data);
      }
    })
  }

  const [avisosInauguracao, setAvisosInauguracao] = React.useState([]);
  const [avisosInauguracaoError, setAvisosInauguracaoError] = React.useState(null);
  const getAvisosInauguracaoPendentes = () => {
    getAvisosPendentes().then(result => {
      if (result.status === 200) {
        setAvisosInauguracaoError(null);
        setAvisosInauguracao(result.data || []);
      } else {
        setAvisosInauguracaoError(result.message || 'Não foi possível carregar os avisos de inauguração.');
      }
    });
  };

  const handleConfirmarAvisoInauguracao = (estabelecimentoId) => {
    confirmarAviso(estabelecimentoId).then(result => {
      if (result && result.status === 200) {
        setAvisosInauguracao(prev => prev.filter(a => a.estabelecimentoId !== estabelecimentoId));
      }
    });
  };

  const { ...rest } = props;
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  // const [image] = React.useState(require("assets/img/sidebar-2.jpg"));
  const [color] = React.useState("blue");
  const [bgColor] = React.useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  const [logo, set_logo] = React.useState("");
  useEffect(() => {
    if(session != null)
      set_logo(process.env.REACT_APP_API_ENDPOINT + "anexos/" + session.logoPequeno);
  }, [session]);  

  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1
    });
  // ref for main panel div
  const mainPanel = React.createRef();

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false      
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });
  
  const sendScrollToTOP = () =>{
    const container = document.querySelector('#divscroll');
    container.scrollTop = 0;
  }

  // functions for changeing the states from components
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getActiveRoute = routes => {    
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }    
    return activeRoute;
  };
  const getRoutes = routes => {
    
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }     
      return (
        <Route          
          path={prop.layout + prop.path}
          //component={prop.component} 
          render={(props) =>  (<prop.component callUpdateScrollTOP={sendScrollToTOP} history={props.history} />)} 
          key={key}          
        />
      );      
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };


  
  return (
    
  <SessionContext.Provider value={session}> 
  
    <div className={classes.wrapper}>
      <Sidebar
        history={props.history}
        routes={routes}
        logoText={"Clinica"}
        logo={logo}
        redirectlogo={"/adminmatriz/home"}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        bgColor={bgColor}
        miniActive={miniActive}
        session={session}
        pathMainUrl="adminmatriz"
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel} id="divscroll">
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          brandText={getActiveRoute(routes) === "" ? "" :t('sidebar.'+getActiveRoute(routes))}
          handleDrawerToggle={handleDrawerToggle}  
          history={props.history}   
          pathMainUrl="adminmatriz" 
          boletinsOcorrencia={boletinsOcorrencia}
          {...rest}
        />
        
          <div className={classes.content} >
            <div className={classes.container + " allowPrint"}>
                <AvisoInauguracao
                  avisos={avisosInauguracao}
                  onConfirmar={handleConfirmarAvisoInauguracao}
                  error={avisosInauguracaoError}
                  onRetry={getAvisosInauguracaoPendentes}
                />
                <Switch>
                  {getRoutes(routes)}
                  {/* Comentei esse codigo, pois sempre que aperta o f5 encaminhava pra home.. ao inves de atualizar a tela atual
                  <Redirect from="/adminmatriz" to="/adminmatriz/home" />*/}
                </Switch>
            </div>
          </div>

        <Footer fluid /> 
      </div>
    </div>
    
    </SessionContext.Provider>
  );
}
